<template>
  <div class="sm:rounded-md shadow p-3 w-full sm:p-2 bg-white">
    <!--    <p class="flex font-semibold text-xl text-red-dark sm:hidden">-->
    <!--      Flora Admin-->
    <!--    </p>-->
    <p class="flex cursor-pointer text-red-dark hover:text-red-medium text-xl justify-end pr-2" @click="goToLogin">
       <span class="sm:inline hidden">
      LogOut
    </span>
      <LogOutIcon class="self-center ml-2"></LogOutIcon>
    </p>
  </div>
</template>

<script>
  import {LogOutIcon} from 'vue-feather-icons'
  import {eventBus} from "../eventbus";

  export default {
    name: "TopBar",
    components: {
      LogOutIcon
    },
    methods:{
      goToLogin(){
        eventBus.$emit('Login')
      }
    }
  }
</script>

<style scoped>

</style>